import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const STORAGE_KEY = 'hwl_cookie_consent_v1';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem(STORAGE_KEY);
      if (!consent) {
        // Slight delay so the banner slides in after the hero paints
        const t = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t);
      }
    } catch {
      // localStorage disabled — show anyway
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ accepted: true, at: new Date().toISOString() }),
      );
    } catch {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 md:px-6 md:pb-6 pointer-events-none"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
    >
      <div className="pointer-events-auto mx-auto max-w-4xl bg-[#3a4a3b] text-[#f6f2ea] shadow-2xl">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 px-5 py-4 md:px-7 md:py-5">
          <p className="text-sm leading-relaxed flex-1">
            We use cookies to keep the site running smoothly, remember your cart and rituals, and
            understand what our herb-loving community enjoys most.{' '}
            <Link
              to="/policies/privacy"
              className="underline underline-offset-4 hover:text-white"
              data-testid="cookie-banner-privacy-link"
            >
              Read our Privacy Policy
            </Link>
            .
          </p>
          <div className="flex items-center gap-2 self-end md:self-auto">
            <button
              onClick={accept}
              className="btn-outline !border-[#dcd6c7] !text-[#dcd6c7] hover:!bg-[#dcd6c7] hover:!text-[#3a4a3b] !py-2 !px-5 text-sm"
              data-testid="cookie-banner-accept-btn"
            >
              Accept
            </button>
            <button
              onClick={accept}
              aria-label="Dismiss cookie notice"
              className="p-2 text-[#dcd6c7] hover:text-white"
              data-testid="cookie-banner-dismiss-btn"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
